export default __webpack_public_path__ + "e0ec6db7cefdafd7ed52fb1cd9df6e0f.png";